import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown, Banknote, Receipt, FileText, TrendingUp, Repeat, BarChart3, FilePieChart } from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { key: "cashflow", title: "Cashflow-Übersicht", desc: "Frei verfügbares Geld + Aufschlüsselung + alle KPIs", icon: TrendingUp },
  { key: "owner", title: "„Was gehört mir wirklich?\"", desc: "Unternehmer-Übersicht: was vom Kontostand ist wirklich freies Geld?", icon: Banknote },
  { key: "vat", title: "USt-Rücklagenbericht", desc: "Vereinnahmt vs. Vorsteuer, empfohlene Rücklage", icon: Receipt },
  { key: "open_receivables", title: "Offene Forderungen", desc: "Alle offenen Kundenrechnungen mit Fälligkeit", icon: FileText },
  { key: "open_payables", title: "Offene Verbindlichkeiten", desc: "Alle offenen Lieferanten-/Freelancer-Rechnungen", icon: FileDown },
  { key: "projects", title: "Projektprofitabilität", desc: "Marge je Projekt netto", icon: BarChart3 },
  { key: "fixed_costs", title: "Fixkostenübersicht", desc: "Wiederkehrende Kosten mit monatlicher Hochrechnung", icon: Repeat },
];

export default function ReportsPage() {
  const download = async (key, title) => {
    try {
      const resp = await api.get(`/reports/${key}`, { responseType: "blob" });
      const url = URL.createObjectURL(resp.data);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler beim Erzeugen des Reports");
    }
  };

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">Reports</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1 flex items-center gap-3">
          <FilePieChart className="h-7 w-7" /> PDF-Exporte
        </h1>
        <p className="text-sm text-neutral-500 mt-2">Druckfreundliche Reports mit deinem Logo und deiner Primärfarbe. Optional auch mit Briefkopf-Hintergrund.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map(({ key, title, desc, icon: Icon }) => (
          <div key={key} className="rounded-xl border border-neutral-200 bg-white p-6 flex flex-col" data-testid={`report-${key}`}>
            <div className="h-10 w-10 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: "var(--tenant-secondary)" }}>
              <Icon className="h-5 w-5" style={{ color: "var(--tenant-primary)" }} />
            </div>
            <div className="font-display font-semibold text-neutral-900">{title}</div>
            <div className="text-sm text-neutral-500 mt-1 flex-1">{desc}</div>
            <Button onClick={() => download(key, title)} className="mt-4 self-start" variant="outline" data-testid={`report-${key}-download`}>
              <FileDown className="h-4 w-4 mr-2" /> PDF erzeugen
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
